var map = {
	"./Icon-Voice.png": 1830,
	"./admin-logo1.png": 1831,
	"./directory.png": 1832,
	"./fail.png": 1833,
	"./jiesan.png": 841,
	"./ku.png": 817,
	"./mb.png": 1834,
	"./normal.png": 607,
	"./sgf.png": 816,
	"./sjs.png": 815,
	"./success.png": 1835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;